import { get, post } from "..";
import useApiActions from "../../recoil/api";

const useExamActions = () => {
  const { getWithToken, postWithToken } = useApiActions();

  return { getGroupLogo, getExamList, getPracticeExamList, isPracticeDone, setPracticeDone };

  async function getExamList(params) {
    const res = await getWithToken("apply/state", params);
    return res;
  }

  async function getPracticeExamList() {
    const res = await getWithToken("apply/sample");
    return res;
  }

  async function getGroupLogo(params) {
    const res = await get("index/getGroupLogo", {
      groupId: params.groupId,
    });
    return res;
  }

  async function isPracticeDone(uid) {
    const res = await postWithToken("apply/is_practice", {
      uid: uid
    });
    return res
  }

  async function setPracticeDone(uid) {
    const res = await postWithToken("apply/set_practice", {
      uid: uid
    });
    return res
  }

  async function endExamCallback() {
    const res = await getWithToken("")
  }
};

export default useExamActions;
